import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { useStore } from "vuex";
import figureFormatter from "@/services/utils/figureFormatter";
import pdfHeaderFooter from '@/services/utils/pdf/pdfHeaderFooter';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
    SulaimanLipi: {
        normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
    }
}
const pdfPrinter = () => {
    const store = useStore();
    const {commaFormat} = figureFormatter();
    const {getHeader, getFooter} = pdfHeaderFooter();

    const userName = store.state.user.user.name;

    const exportToPDF = (company, saleItemData, isItem = false, isCustomer = false, startDate = '', endDate = '', params = {}) => {
        var doc = {
            pageSize: 'A4',
            pageMargins: [10, 100, 10, 80],
            pageOrientation: 'landscape',
            header: getHeader(company),
            footer: getFooter(userName),
            content: getContent(saleItemData, isItem, isCustomer, startDate, endDate, params),

            styles: {
                header: {
                    fontSize: 24,
                }
            },

            defaultStyle: {
                color: 'black',
                fontSize: 8,
                font: 'SulaimanLipi'
            },

            info: {
                title: 'Sale Register' + (isItem ? ' Item ' : (isCustomer ? ' Customer ' : '')) + '(' + startDate + ' to ' + endDate + ')',
            }
        }

        pushIntoTable(doc, saleItemData,isItem,isCustomer)

        const pdfDocGenerator = pdfMake.createPdf(doc);
        pdfDocGenerator.open();
    }

    const getContent = (saleItemData, isItem, isCustomer, startDate, endDate, params) => {
        return [
            {
                text: 'Sale Register' + (isItem ? ' Item ' : (isCustomer ? ' Customer ' : '')) + '(' + startDate + ' to ' + endDate + ')',
                style: 'header',
                alignment: 'center',
                margin: [0, 0, 20, 10],
                bold: true,
                color: 'black',
                fontSize: 12,
                decoration: 'underline'
            },

            {
                margin: [0, 10, 0, 0],
                alignment: 'justify',
                columns: [
                    {
                        width: '50%',
                        stack: [
                            {
                                text: `${params.contact_profile ? 'Party: ' +  getTopHeadData(saleItemData.data, 'customer_name') : ''}`,
                                color: 'black',
                                bold: true,
                            },

                            {
                                text: `${params.product_type ? 'Product Type: ' +  getTopHeadData(saleItemData.data, 'product_type') : ''}`,
                                color: 'black',
                                bold: true,
                            },

                        ]

                    },

                    {
                        alignment: 'right',
                        stack: [
                            {
                                text: `${params.product_id ? 'Product: ' +  getTopHeadData(saleItemData.data, 'product_name') : ''}`,
                                color: 'black',
                                bold: true,
                            },
                            {
                                text: `${params.project ? 'Project: ' +  getTopHeadData(saleItemData.data, 'project_name') : ''}`,
                                color: 'black',
                                bold: true,
                            },
                        ]
                    },
                ]
            },


            {
                style: 'tableExample',
                margin: [0, 10, 0, 0],
                table: {
                    body: [],
                    widths: getWidth(isItem,isCustomer)
                },
                layout: {
                    fillColor: function (rowIndex, node, columnIndex) {
                        return (rowIndex === 0) ? '#f3f2f7' : null;
                    },
                    hLineWidth: function (i, node) {
                        return 0.5;
                    },
                    vLineWidth: function (i, node) {
                        return 0.5;
                    }
                }
            },
        ]
    }

    const getWidth = (isItem,isCustomer) => {
        if (isItem){
            return [ 'auto', '*','*', '*', '*', '*', '*', '*', '*', '*' ]
        }
        if (isCustomer){
            return [ 'auto', '*','*', 'auto','auto', 'auto', 'auto', '*', '*', '*', '*', '*', '*' ]
        }
    }

    const pushIntoTable = (doc, saleItemData,isItem,isCustomer) => {
        const tableItems = saleItemData.data;
        const tableHeader = getTableHeader(isItem,isCustomer);
        doc.content[2].table.body.push(tableHeader);

        tableItems.forEach((item,i) => {
            const rowData = getRowData(item,isItem,isCustomer,i);
            return doc.content[2].table.body.push(rowData);
        });

        const getLastRow = getTotal(saleItemData.total,isItem,isCustomer)
        doc.content[2].table.body.push(getLastRow);
    }

    const getTopHeadData = (items, field) => {
        if (!items || items.length === 0) return '';

        const firstItem = items[0];
        if (!firstItem.hasOwnProperty(field) || firstItem[field] === null || firstItem[field] === undefined) {
            return '';
        }

        return firstItem[field]
            .toString()
            .replace(/_/g, ' ')
            .replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
    }

    const getTableHeader = (isItem,isCustomer) => {
        let tableHeader = [];
        if (isItem) {
            tableHeader = [
                {text: 'SL#'},
                {text: 'Item'},
                {text: 'Sales Qty', alignment: 'right'},
                {text: 'Bonus Qty', alignment: 'right'},
                {text: 'Total Qty', alignment: 'right'},
                {text: 'Invoice Amount', alignment: 'right'},
                {text: 'VAT Amount', alignment: 'right'},
                {text: 'Total Amount', alignment: 'right'},
                {text: 'COGS', alignment: 'right'},
                {text: 'Gross Profit', alignment: 'right'},
            ];
        }

        if (isCustomer) {
            tableHeader = [
                {text: 'SL#'},
                {text: 'Customer Name'},
                {text: 'Contact No'},
                {text: 'Sales Qty', alignment: 'right'},
                {text: 'Bonus Qty', alignment: 'right'},
                {text: 'Total Qty', alignment: 'right'},
                {text: 'Invoice Amount', alignment: 'right'},
                {text: 'VAT Amount', alignment: 'right'},
                {text: 'Total Amount', alignment: 'right'},
                {text: 'Discount Amount', alignment: 'right'},
                {text: 'Net Bill Amount', alignment: 'right'},
                {text: 'COGS', alignment: 'right'},
                {text: 'Gross Profit', alignment: 'right'},
            ];
        }

        return tableHeader;
    }
    const getRowData = (item,isItem,isCustomer,i) => {
        let tableRow = [];
        if (isItem) {
            tableRow = [
                {text: i + 1},
                {text: item.product_name},
                {text: item.net_quantity, alignment: 'right'},
                {text: item.bonus_quantity, alignment: 'right'},
                {text: item.total_bonus_quantity, alignment: 'right'},
                {text: commaFormat(item.net_invoice_amount), alignment: 'right'},
                {text: commaFormat(item.total_vat_amount), alignment: 'right'},
                {text: commaFormat(item.total_vat_amount + item.net_invoice_amount), alignment: 'right'},
                {text: commaFormat(item.stocks_sum_stock_value), alignment: 'right'},
                {text: commaFormat(item.stocks_sum_profit_value), alignment: 'right'},
            ];
        }

        if (isCustomer) {
            tableRow = [
                {text: i + 1},
                {text: item.customer_name},
                {text: (item.phone ? item.phone + ',' : '') +  (item.mobile_no ? item.mobile_no : '') },
                {text: item.net_quantity, alignment: 'right'},
                {text: item.bonus_quantity, alignment: 'right'},
                {text: item.total_bonus_quantity, alignment: 'right'},
                {text: commaFormat(item.net_invoice_amount), alignment: 'right'},
                {text: commaFormat(item.total_vat_amount), alignment: 'right'},
                {text: commaFormat(item.total_vat_amount + item.net_invoice_amount), alignment: 'right'},
                {text: commaFormat(item.total_discount), alignment: 'right'},
                {text: commaFormat(item.total_sale_amount - item.total_discount), alignment: 'right'},
                {text: commaFormat(item.stocks_sum_stock_value), alignment: 'right'},
                {text: commaFormat(item.stocks_sum_profit_value), alignment: 'right'},
            ];
        }

        return tableRow
    }

    const getTotal = (totalValue,isItem,isCustomer) => {

        let lastRow = [];
        if (isItem){
            lastRow = [
                {
                    text: 'Total',
                    alignment: 'right',
                    colSpan:2,
                },
                '',
                {
                    text: totalValue.total_net_quantity,
                    alignment: 'right'
                },
            
                {
                    text: totalValue.total_bonus_quantity,
                    alignment: 'right'
                },
            
                {
                    text: totalValue.total_total_bonus_quantity,
                    alignment: 'right'
                },
            
                {
                    text: totalValue.total_net_invoice_amount,
                    alignment: 'right'
                },
            
                {
                    text: totalValue.total_vat_amount,
                    alignment: 'right'
                },
            
                {
                    text: totalValue.total_net_invoice_vat_amount,
                    alignment: 'right'
                },
                {
                    text: totalValue.stocks_sum_stock_value,
                    alignment: 'right'
                },
            
                {
                    text: totalValue.stocks_sum_profit_value,
                    alignment: 'right'
                },
            ]
        }

        if (isCustomer){
            lastRow = [
                {
                    text: 'Total',
                    alignment: 'right',
                    colSpan:3
                },
                '','',
                {
                    text: totalValue.total_net_quantity,
                    alignment: 'right'
                },

                {
                    text: totalValue.total_bonus_quantity,
                    alignment: 'right'
                },

                {
                    text: totalValue.total_total_bonus_quantity,
                    alignment: 'right'
                },

                {
                    text: totalValue.total_net_invoice_amount,
                    alignment: 'right'
                },

                {
                    text: totalValue.total_vat_amount,
                    alignment: 'right'
                },

                {
                    text: totalValue.total_net_invoice_vat_amount,
                    alignment: 'right'
                },

                {
                    text: totalValue.discount_amount,
                    alignment: 'right'
                },

                {
                    text: totalValue.total_net_bill_amount,
                    alignment: 'right'
                },

                {
                    text: totalValue.stocks_sum_stock_value,
                    alignment: 'right'
                },

                {
                    text: totalValue.stocks_sum_profit_value,
                    alignment: 'right'
                },
            ]
        }

        return lastRow
    }

    return {
        exportToPDF
    }

}

export default pdfPrinter;